export const testCharacters = [
  {
    "__typename": "Character",
    "id": "1",
    "name": "A-Bomb",
    "intelligence": 38,
    "strength": 100,
    "speed": 17,
    "durability": 80,
    "power": 24,
    "combat": 64,
    "fullName": "Richard Milhouse Jones",
    "publisher": "Marvel Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/10060.jpg"
},
{
    "__typename": "Character",
    "id": "2",
    "name": "Abe Sapien",
    "intelligence": 88,
    "strength": 28,
    "speed": 35,
    "durability": 65,
    "power": 100,
    "combat": 85,
    "fullName": "Abraham Sapien",
    "publisher": "Dark Horse Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/956.jpg"
},
{
    "__typename": "Character",
    "id": "3",
    "name": "Abin Sur",
    "intelligence": 50,
    "strength": 90,
    "speed": 53,
    "durability": 64,
    "power": 99,
    "combat": 65,
    "fullName": "",
    "publisher": "DC Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1460.jpg"
},
{
    "__typename": "Character",
    "id": "4",
    "name": "Abomination",
    "intelligence": 63,
    "strength": 80,
    "speed": 53,
    "durability": 90,
    "power": 62,
    "combat": 95,
    "fullName": "Emil Blonsky",
    "publisher": "Marvel Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1.jpg"
},
{
    "__typename": "Character",
    "id": "5",
    "name": "Abraxas",
    "intelligence": 88,
    "strength": 63,
    "speed": 83,
    "durability": 100,
    "power": 100,
    "combat": 55,
    "fullName": "Abraxas",
    "publisher": "Marvel Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/181.jpg"
},
{
    "__typename": "Character",
    "id": "6",
    "name": "Absorbing Man",
    "intelligence": 38,
    "strength": 80,
    "speed": 25,
    "durability": 100,
    "power": 98,
    "combat": 64,
    "fullName": "Carl Creel",
    "publisher": "Marvel Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1448.jpg"
},
{
    "__typename": "Character",
    "id": "7",
    "name": "Adam Monroe",
    "intelligence": 63,
    "strength": 10,
    "speed": 12,
    "durability": 100,
    "power": 100,
    "combat": 64,
    "fullName": "",
    "publisher": "NBC - Heroes",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1026.jpg"
},
{
    "__typename": "Character",
    "id": "8",
    "name": "Adam Strange",
    "intelligence": 69,
    "strength": 10,
    "speed": 33,
    "durability": 40,
    "power": 37,
    "combat": 50,
    "fullName": "Adam Strange",
    "publisher": "DC Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/626.jpg"
},
{
    "__typename": "Character",
    "id": "10",
    "name": "Agent Bob",
    "intelligence": 10,
    "strength": 8,
    "speed": 13,
    "durability": 5,
    "power": 5,
    "combat": 20,
    "fullName": "Bob",
    "publisher": "Marvel Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/10255.jpg"
},
{
    "__typename": "Character",
    "id": "11",
    "name": "Agent Zero",
    "intelligence": 75,
    "strength": 28,
    "speed": 38,
    "durability": 80,
    "power": 72,
    "combat": 95,
    "fullName": "Christoph Nord",
    "publisher": "Marvel Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/396.jpg"
},
{
    "__typename": "Character",
    "id": "12",
    "name": "Air-Walker",
    "intelligence": 50,
    "strength": 85,
    "speed": 100,
    "durability": 85,
    "power": 100,
    "combat": 40,
    "fullName": "Gabriel Lan",
    "publisher": "Marvel Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1358.jpg"
},
{
    "__typename": "Character",
    "id": "13",
    "name": "Ajax",
    "intelligence": 56,
    "strength": 48,
    "speed": 35,
    "durability": 80,
    "power": 34,
    "combat": 55,
    "fullName": "Francis",
    "publisher": "Marvel Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/10422.jpg"
},
{
    "__typename": "Character",
    "id": "14",
    "name": "Alan Scott",
    "intelligence": 63,
    "strength": 80,
    "speed": 23,
    "durability": 90,
    "power": 100,
    "combat": 32,
    "fullName": "Alan Ladd Wellington Scott",
    "publisher": "DC Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/698.jpg"
},
{
    "__typename": "Character",
    "id": "15",
    "name": "Alex Mercer",
    "intelligence": 50,
    "strength": 80,
    "speed": 42,
    "durability": 90,
    "power": 100,
    "combat": 50,
    "fullName": "Alexander J. Mercer",
    "publisher": "Wildstorm",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/10398.jpg"
},
{
    "__typename": "Character",
    "id": "17",
    "name": "Alfred Pennyworth",
    "intelligence": 63,
    "strength": 10,
    "speed": 17,
    "durability": 10,
    "power": 7,
    "combat": 55,
    "fullName": "Alfred Thaddeus Crane Pennyworth",
    "publisher": "DC Comics",
    "alignment": "good",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/628.jpg"
},
{
    "__typename": "Character",
    "id": "18",
    "name": "Alien",
    "intelligence": 50,
    "strength": 28,
    "speed": 42,
    "durability": 90,
    "power": 57,
    "combat": 60,
    "fullName": "Xenomorph",
    "publisher": "Dark Horse Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/10449.jpg"
},
{
    "__typename": "Character",
    "id": "20",
    "name": "Amazo",
    "intelligence": 63,
    "strength": 100,
    "speed": 83,
    "durability": 100,
    "power": 100,
    "combat": 100,
    "fullName": "",
    "publisher": "DC Comics",
    "alignment": "bad",
    "image": "https://www.superherodb.com/pictures2/portraits/10/100/1390.jpg"
},
];
